import { TShippingFormInstance } from 'widgets/checkout/ShippingForm';
import { TCheckoutMgr } from 'widgets/checkout/CheckoutMgr';
import { getUrlParams } from 'widgets/toolbox/util';
import { TOrderModel } from 'types/models/order';

/**
 * @description Checkout Shipping step logic
 *
 * @param CheckoutMgr Base widget for extending
 */
function ShippingStepMixinClassCreator(CheckoutMgr: TCheckoutMgr) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class ShippingStepMixin
     * @augments TCheckoutMgr
     * @subcategory checkout
     * @classdesc Represents shipping step component with the next features:
     * 1. Manage Shipping step state on the checkout
     * 2. Submit shipping form
     */
    class ShippingStepMixin extends CheckoutMgr {
        /**
         * @description Activate shipping step
         */
        shippingActivate() {
            this.getById(
                this.prefs().shippingFormID,
                (shippingFormComponent: TShippingFormInstance) => {
                    shippingFormComponent.activate({
                        order: this.order,
                        customer: this.customer
                    });

                    const urlParams = <{errorMessageOnStepActivate: string}> getUrlParams();

                    if (urlParams.errorMessageOnStepActivate) {
                        shippingFormComponent.setError(urlParams.errorMessageOnStepActivate.toString());
                    }
                }
            );
            this.eventBus().emit('checkout.shipping.step.activated', this);
        }

        /**
         * @description Deactivate shipping step
         */
        shippingDeActivate() {
            // Placeholder for additional logic on shipping deactivation
        }

        /**
         * @description Submit shipping form
         */
        shippingSubmit(): void | Promise<void> {
            this.getById(this.prefs().shippingFormID, (shippingFormComponent: TShippingFormInstance) => {
                shippingFormComponent.submit();
            });
        }

        /**
         *
         * @description Shipping submission result handler
         * @param shippingForm - Shipping form widget
         * @param data - Submission response from server
         * @listens ShippingForm#submit
         */
        shippingSubmitted(shippingForm: TShippingFormInstance, data: Record<string, unknown>) {
            if (data.order) {
                this.order = <TOrderModel>data.order;
            }

            this.callIfExists('updateSummaryAndNext', shippingForm, data);
        }
    }

    return ShippingStepMixin;
}

export type TShippingStepMixin = ReturnType<typeof ShippingStepMixinClassCreator>;

export type TShippingStepMixinInstance = InstanceType<TShippingStepMixin>;

export default ShippingStepMixinClassCreator;
